export default __webpack_public_path__ + "media/images/tel-99769a38.png";